module.exports = __webpack_public_path__ + "static/media/icon_retail.03ef10c3.svg";